module.exports = __webpack_public_path__ + "static/media/08d.a212f853.svg";